import { render, staticRenderFns } from "./beneficiary.vue?vue&type=template&id=38bf7b76&scoped=true&"
import script from "./beneficiary.vue?vue&type=script&lang=js&"
export * from "./beneficiary.vue?vue&type=script&lang=js&"
import style0 from "./beneficiary.vue?vue&type=style&index=0&id=38bf7b76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bf7b76",
  null
  
)

export default component.exports